var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Information"},[_c('Part1'),_c('Part2')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }